module.exports = __webpack_public_path__ + "img/LogoENE.132c4681.png";